import { SigningRequestLayout } from './SigningRequestLayout';

export function SignTransaction() {
  return <SigningRequestLayout isTransaction={true} />;
}
